import API from 'api';
import { currentCompanyId } from 'utils/company';
import * as C from './constants';
import receiveNetworkException from './network';
import { setCompany } from './companies';
import error from './error';
import * as ReportModels from './models/report';

export const loadSuccess = (res) => ({
  type: C.LOAD_REPORTS_SUCCESS,
  data: res,
});

export const setReport = (report) => (dispatch) => dispatch({ type: C.SET_REPORT, data: report });

export const closeReport = () => (dispatch) => new Promise((resolve) => {
  localStorage.removeItem('selectedReport');
  resolve(dispatch({ type: C.CLOSE_REPORT }));
});

const sameCompanyAsCurrent = (company) => (
  company && company.id === currentCompanyId()
);

export const load = (props) => (dispatch) => {
  dispatch({ type: C.LOAD_REPORTS });
  return API.reports.load(props)
    .then(({ body: { data, included, meta } }) => (
      dispatch(loadSuccess({
        list: ReportModels.ReportsList(data, included),
        count: meta.records_count,
      }))
    ))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_REPORTS_ERROR, 'Error loading reports'));
    });
};

export const get = (reportId) => (dispatch) => {
  dispatch({ type: C.LOAD_REPORT });
  return API.reports.load({ id: reportId })
    .then(({ body: { data, included } }) => ReportModels.Report({ report: data, included }))
    .then((report) => {
      localStorage.setItem('selectedReport', JSON.stringify(report));
      return report;
    })
    .then((report) => {
      if (sameCompanyAsCurrent(report.company)) {
        return dispatch({ type: C.LOAD_REPORT_SUCCESS, data: { report } });
      }
      setCompany(report.company)(dispatch);
      return get(reportId)(dispatch);
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_REPORT_ERROR, 'Error loading reports'));
    });
};

export const create = (data) => (dispatch) => {
  dispatch({ type: C.CREATE_REPORT });
  return API.reports.create(ReportModels.CreateReport(data))
    .then((res) => (res.statusCode === 201 ? (
      dispatch({ type: C.CREATE_REPORT_SUCCESS })
    ) : (
      dispatch(error(C.CREATE_REPORT_ERROR, 'Error creating report'))
    )))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.CREATE_REPORT_ERROR, 'Error creating report'));
    });
};

export const update = (reportId, data) => (dispatch) => {
  dispatch({ type: C.UPDATE_REPORT });
  return new Promise((resolve, reject) => (
    API.reports.update(reportId, ReportModels.UpdateReport(reportId, data))
      .then(() => dispatch({ type: C.UPDATE_REPORT_SUCCESS }))
      .then(() => resolve())
      .catch((e) => {
        dispatch(receiveNetworkException(e));
        dispatch(error(C.UPDATE_REPORT_ERROR, 'Error updating report'));
        reject();
      })
  ));
};

export const updateAccess = (reportIds, actions) => (dispatch) => {
  dispatch({ type: C.UPDATE_REPORT });
  return new Promise((resolve, reject) => (
    API.reports.updateAccess(ReportModels.UpdateAccess(reportIds, actions))
      .then(() => dispatch({ type: C.UPDATE_REPORT_SUCCESS }))
      .then(() => resolve())
      .catch((e) => {
        dispatch(receiveNetworkException(e));
        if (e.response.data.errors[0].title.error == "email_already_taken"){
          let email = e.response.data.errors[0].title.email;
          dispatch(error(C.UPDATE_REPORT_ERROR, {
            message: 'Error managing access',
            description: `${email} is already assigned to another user than 'dashboard_viewer' role. Invitation process was cancelled.`,
          }));
        } else {
          dispatch(error(C.UPDATE_REPORT_ERROR, 'Error updating report'));
        }
        reject();
      })
  ));
};

export const archive = (reportId, data) => (dispatch) => {
  dispatch({ type: C.ARCHIVE_REPORT });
  return API.reports.archive(reportId, ReportModels.ArchiveReport(reportId, data))
    .then((res) => {
      if (res.statusCode === 200) {
        dispatch({ type: C.ARCHIVE_REPORT_SUCCESS });
      } else {
        dispatch(error(C.ARCHIVE_REPORT_ERROR, 'Error archiving report'));
      }
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.ARCHIVE_REPORT_ERROR, 'Error archiving report'));
    });
};

export const hide = (reportId, data) => (dispatch) => {
  dispatch({ type: C.HIDE_REPORT });
  return API.reports.hide(reportId, ReportModels.HideReport(reportId, data))
    .then((res) => {
      if (res.statusCode === 200) {
        dispatch({ type: C.HIDE_REPORT_SUCCESS });
      } else {
        dispatch(error(C.HIDE_REPORT_ERROR, 'Error hiding report'));
      }
    })
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.HIDE_REPORT_ERROR, 'Error hiding report'));
    });
};

export const remove = (reportId) => (dispatch) => {
  dispatch({ type: C.DELETE_REPORT });
  return API.reports.remove(reportId)
    .then((res) => (res.statusCode === 204 ? (
      dispatch({ type: C.DELETE_REPORT_SUCCESS })
    ) : (
      dispatch(error(C.DELETE_REPORT_ERROR, 'Error deleting report'))
    )))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.DELETE_REPORT_ERROR, 'Error deleting report'));
    });
};
